import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  IncomeCostDeleteInput,
  IncomeCostModel,
  IncomeCostMutationInput,
  IncomeCostUpdateInput,
} from './model';

export function useCreateIncomeCost(
  options?: UseMutationOptions<
    ApiResult<IncomeCostModel>,
    ApiError,
    IncomeCostMutationInput
  >,
): UseMutationResult<
  ApiResult<IncomeCostModel>,
  ApiError,
  IncomeCostMutationInput
> {
  return useMutation<
    ApiResult<IncomeCostModel>,
    ApiError,
    IncomeCostMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'income-and-costs',
      method: 'POST',
      classType: IncomeCostModel,
      body,
    });
  }, options);
}

export function useUpdateIncomeCost(
  options?: UseMutationOptions<
    ApiResult<IncomeCostModel>,
    ApiError,
    IncomeCostUpdateInput
  >,
): UseMutationResult<
  ApiResult<IncomeCostModel>,
  ApiError,
  IncomeCostUpdateInput
> {
  return useMutation<
    ApiResult<IncomeCostModel>,
    ApiError,
    IncomeCostUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `income-and-costs/${body.incomeCostId}`,
      method: 'PUT',
      classType: IncomeCostModel,
      body: body.body,
    });
  }, options);
}

export function useDeleteIncomeCost(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    IncomeCostDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, IncomeCostDeleteInput> {
  return useMutation<{ message: string }, ApiError, IncomeCostDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `income-and-costs/${body.incomeCostId}/void`,
        method: 'PATCH',
      });
    },
    options,
  );
}
